export default {
  header: 'Siste bevegelser',
  empty: 'Ingen bevegelser ennå.',
  date: 'Dato',
  direction: 'Retning',
  product: 'Produkt',
  bottleSize: 'Flaskestørrelse',
  amount: 'Mengde',
  batchId: 'Batch-ID',
  uniqueId: 'Unik ID',
  note: 'Notat',
  sold: 'SOLGT',
  out: 'UT',
  in: 'INN',
};
